import { useIsUngatedForIARedesign } from '../hooks/useIsUngatedForIARedesign';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Simple convenience component that renders different content based on whether the user has access to the IARedesign gate.
 * You can specify additional gates that will be checked in addition to the IARedesign gate.
 * Defaults to empty content for the truthy case if none is provided.
 */
export const IARedesignSwitch = ({
  gatedContent = null,
  ungatedContent = null,
  secondaryGates = []
}) => {
  const isUngatedForIARedesign = useIsUngatedForIARedesign(...secondaryGates);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isUngatedForIARedesign ? ungatedContent : gatedContent
  });
};